export const CACHE_INFO_LIST_NAME = 'cacheInfo'
